/** A failure that must not change what the caller does next still has to be visible. */
export function reportSwallowed(where: string, err: unknown): void {
  console.warn(where, err);
}
